import React, { Component } from 'react';
import './layout.css';
import './buttons.css';
import './colors.css';

export class LinkBox extends Component {
  render() {
    return (
      <div className={"linkbox "+this.props.box.className}>
        <div className="list-group-title">{this.props.box.title}</div>
        {this.props.box.links.map((link, ilink) => {
          return (
            <a key={ilink} href={link.href} className="list-group-item">
              {link.text}
            </a>
          )
        })}
      </div>
    )
  }
}

// "gradient-btn"
// "transparent-btn transparent-btn-1"
// "blue-rounded-btn"
// "image-btn"
export class TopLine extends Component {
  render() {
    let className = "topline " + this.props.box.className;
    return (
      <div className={className}>
        {this.props.box.links.map((button, ibutton) => {
          return button.href ? (
            <a key={ibutton} className="blue-rounded-btn" href={button.href}>
              {button.text}
            </a>
          ) : (
            <div key={ibutton} className="topline-label">{button.text}</div>
          )
        })}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/lib.js